import ar from '@/local/ar';
import Vue from '@/main';
import {
  setLookupInLocalStorage,
  setSubLookupInLocalStorage,
} from '../helpers/utils';
import api from '../services/api';

export default {
  updateLookup(store, payload) {
    store.dispatch('clearLookup', payload.lookupKey);
    store.dispatch(payload.actionName);
  },
  updateSubLookup(store, payload) {
    store.dispatch('clearSubLookup', payload);
    store.dispatch(payload.actionName, payload.relatedId);
  },
  clearLookup(store, lookupKey) {
    setLookupInLocalStorage(lookupKey, []);
  },
  clearSubLookup(store, payload) {
    setSubLookupInLocalStorage(payload.relatedId, payload.lookupKey, []);
  },
  getApplyTypes(store) {
    return getData(store, 'applyTypes', 'getApplyTypes', 'صفة مقدم الشكوى');
  },
  getCountries(store) {
    return getData(store, 'countries', 'getCountries', 'الدول');
  },
  getCitiesByRegion(store, payload) {
    return getDataByRelatedId(store, payload, 'subCities', 'getCitiesByRegion', 'المدن');
  },
  getDistrictsByCity(store, payload) {
    return getDataByRelatedId(store, payload, 'districts', 'getDistrictsByCity', 'الاحياء');
  },
  getDepartmentsByCourtIds(store, payload) {
    return api.getDepartmentsByCourtIds(payload);
  },
};

const getData = ({ commit, state }, key, apiService, error, mapper = data => data, storeInLocalStorage = true) => {
  if (!state[key].length) {
    commit('update', {
      key,
      data: [],
    });
    return api[apiService]()
      .then((res) => {
        const data = mapper(res.data);
        commit('update', {
          key,
          data,
        });
        if (storeInLocalStorage) setLookupInLocalStorage(key, data);
        return data;
      })
      .catch((err) => {
        !err.handled && Vue.toaster.error(ar.errors.wentWrongWhile(error));
        return [];
      });
  } else {
    return Promise.resolve(state[key]);
  }
};

const getDataByRelatedId = (
  { commit, state },
  relatedId,
  key,
  apiService,
  error,
  mapper = data => data,
  storeInLocalStorage = true
) => {
  if (relatedId !== undefined) {
    if (!state[key][relatedId] || !state[key][relatedId].length) {
      return api[apiService](relatedId)
        .then((res) => {
          const data = mapper(res.data);
          commit('updateSubLookup', {
            relatedId,
            key,
            data,
          });
          if (storeInLocalStorage) setSubLookupInLocalStorage(relatedId, key, data);
          return data;
        })
        .catch((err) => {
          !err.handled && Vue.toaster.error(ar.errors.wentWrongWhile(error));
          return [];
        });
    } else {
      return Promise.resolve(state[key][relatedId]);
    }
  } else {
    return Promise.resolve([]);
  }
};
